var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-component":""}},[(_vm.$responsive.is('pc'))?_c('layout-pc',{attrs:{"items":_vm.items}}):_vm._e(),_vm._v(" "),(_vm.$responsive.is('mobile'))?_c('layout-mobile',{attrs:{"items":_vm.items}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }